var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"block","position":"fixed","left":"0","top":"0","width":"100%","height":"100vh"},style:(_vm.backgroundStyle(_vm.$vuetify.breakpoint.name))})}
var staticRenderFns = []

export { render, staticRenderFns }